import React from "react";
import AdvisoryTable from "./List/AdvisryList";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import "../../../components/common/css/datatable.scss";
import "../../../components/common/css/index.scss";

const Advisory = () => {
  
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <AdvisoryTable/>
      </div>
    </div>
  );
};

export default Advisory;
